export default __webpack_public_path__ + "static/img-ei-3-0c6879e0ca56f10c9008e5e1eaa3978b.png";